import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import 'slick-carousel';

Snappy.Component.GlobalHeroCarousel = class GlobalHeroCarousel extends Snappy.BaseComponent {
    static get tagName() {
        return 'global-hero-carousel';
    }

    constructor(element) {
        super(element);
    }

    render() {
       

        $('.loadVideo').click(function () {
            console.log("click");
            var options = {
                videoId: $(this).attr('video-id'),
                videoUrl: $(this).attr('video-url'),
                videoToken: $(this).attr('video-token'),
                streamAmgVideoId: $(this).attr('stream-amg-video-id'),
                amgPartnerId: $(this).attr('amg-partner-id'),
                amgConfigId: $(this).attr('amg-config-id'),
                videoTitle: $(this).attr('data-title'),

            };
            loadVideo(options);

        });

        function loadVideo(options) {
            var defaults = {};
            var settings = $.extend(options, defaults);

            $(this).closest(".carousel").slick("slickPause");
            if (settings.videoUrl !== undefined) {
                loadYouTubeVideo(settings);
            }
            else if (settings.videoId !== undefined) {
                
                loadGrabyoVideo(settings);
            }
            
        };

        function loadGrabyoVideo(options) {
            var defaults = {};
            var settings = $.extend(options, defaults);
            $(".fa-modal .js-modal-contents").append('<div class="grabyo-widget" data-path="embed.jsp?assetId=' + settings.videoId + '&render="  data-medium="embed" data-tag="videoembed"></div><script src="//grabyo.com/js/widgets.js" type="text/javascript" async />');
            $(".fa-modal .js-modal-title").empty();
            $("body").addClass("fa-modal--modal-open");
            $(".fa-modal .js-modal-title").append(settings.videoTitle);
        }

        function loadYouTubeVideo(options) {     
            var defaults = {};
            var settings = $.extend(options, defaults);
            let videoId;
            videoId = settings.videoUrl.split("=").slice(-1)
            $(".fa-modal .js-modal-title").empty();
            $(".fa-modal .js-modal-contents").empty();
        
            $(".fa-modal .js-modal-contents").append('<div class="videoPlaceholder"><iframe class="youtubeVideo" width="560" height="315" src= "https://www.youtube.com/embed/' + videoId + '?&autoplay=0&rel=1"frameborder = "0" allowfullscreen ></iframe ></div>');
            $("body").addClass("fa-modal--modal-open");
            $(".fa-modal .js-modal-title").append(settings.videoTitle);
        }

        function loadAmgVideo(options) {
            var defaults = {};
            var settings = $.extend(options, defaults);
            $(".wlc-modal").addClass("wlc-modal__open");
            kWidget.embed({
                "targetId": "wlc-modal__video",
                "wid": "_" + settings.amgPartnerId,
                "uiconf_id": settings.amgConfigId,
                "flashvars": {
                    "ks": settings.videoToken,
                    "autoPlay": false
                },
                "cache_st": 1520883895,
                "entry_id": settings.streamAmgVideoId
            });

        }
        
        $(".js-modal-close").click(function () {
            $(this).closest(".carousel").slick("slickPlay");
            $(".fa-modal .js-modal-contents").empty();
            $(".fa-modal .js-modal-title").empty();
        })
        
    };
 

}






// WEBPACK FOOTER //
// ./components/global-heroCarousel/scripts/global-hero-carousel.js